<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
  <span class="relative">
    <span class="relative">
      @if (showAvatar && userAvatar) {
        <img class="w-7 h-7 rounded-full" [src]="userAvatar">
      }
      @if (!showAvatar || !userAvatar) {
        <mat-icon class="icon-size-7 mt-1"
        [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      }
    </span>
        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{
                        'bg-green-500': userState === 'online',
                        'bg-amber-500': userState === 'away',
                        'bg-red-500': userState === 'busy',
                        'bg-gray-400': userState === 'not-visible'}">
    </span>
  </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex flex-col leading-none">
      <span>Sesión iniciada como:</span>
      <span class="mt-1.5 text-md font-medium">{{userEmail}}</span>
    </span>
  </button>
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="loadProfile()">
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>Perfil</span>
  </button>
  <button mat-menu-item>
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>Configuración</span>
  </button>
  <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
  <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
  <span>Estado</span>
</button> -->
<mat-divider class="my-2"></mat-divider>
<button mat-menu-item (click)="signOut()">
  <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
  <span>Salir</span>
</button>
</mat-menu>

<!-- <mat-menu class="user-status-menu" #userStatus="matMenu">
<button mat-menu-item (click)="updateUserStatus('online')">
  <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
  <span>En línea</span>
</button>
<button mat-menu-item (click)="updateUserStatus('away')">
  <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
  <span>Ausente</span>
</button>
<button mat-menu-item (click)="updateUserStatus('busy')">
  <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
  <span>No disponible</span>
</button>
<button mat-menu-item (click)="updateUserStatus('not-visible')">
  <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
  <span>Invisible</span>
</button>
</mat-menu> -->